module.exports = __webpack_public_path__ + "static/media/logo.9925c0a5.png";